export const PartnersSubMenuRoutes = {
  DEFAULT: '/customer-management',
  CUSTOMER_MANAGEMENT: '/customer-management',
  DASHBOARD: '/partners-dashboard',
  LEAD_MANAGEMENT: '/partners-lead-management',
};
